<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
					<el-form-item label="抽佣(单位：%)">
						<el-input-number v-model="commissionRatio" :min="0" :max="100"></el-input-number>
					</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="confirm">设置</el-button>
				</el-form-item>
				<el-form-item style="float:right">
					<span class="amount">当前总金额：{{amount}}</span>
					<el-button type="primary" v-on:click="refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<el-table :data="tableData" highlight-current-row v-loading="listLoading" style="width: 100%;">
			<!-- <el-table-column type="selection" width="45"></el-table-column> -->
			<el-table-column prop="time" label="汇总日期"  :formatter="formateDate" max-width="130">
			</el-table-column>
			<!-- <el-table-column prop="income" label="当天佣金"  width="120">
			</el-table-column> -->
			<el-table-column prop="open" label="打开佣金"  width="120">
			</el-table-column>
			<el-table-column prop="share" label="分享佣金"  width="120">
			</el-table-column>
			<el-table-column prop="remainder" label="累积总额" width="120">
			</el-table-column>
		</el-table>
		<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page=page
				:page-sizes="[10, 20, 30]"
				:page-size="10"
				layout="total, sizes, prev, pager, next, jumper"
				:total=totalNumber>
		</el-pagination>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	import { getUserListPage, removeUser, batchRemoveUser, editUser, addUser } from '../../api/api';

	export default {
		data() {
			return {
				amount: null,
				commissionRatio: 0,
				loadingPass: false,
				loadingUnpass: false,
				checkVisible: false,
				settingVisible: false,
				currentId: null,
				currentItem: null,
				chargeFormVisible: false,
				selcetedCheckState: null,
				selectedState: null,
				multipleSelection: [],
				totalNumber: null,
				tableData: null,
				pageSize: 10,
				currentPage: 1,
				statusState: [{ label: '待处理', value: 'WAITING' }, { label: '已处理', value: 'COMPLETE' },],
				checkState: [{ label: '审核中', value: 'WAITING' }, { label: '审核通过', value: 'PASSED' }, { label: '不通过', value: 'REJECTED' }],
				filters: {
					name: ''
				},
				users: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入金额', trigger: 'blur' }
					]
				},
				//新增界面数据
				addForm: {
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				},
				chargeLoading: false,
				chargeForm: {
					money: 0,
				}

			}
		},
		methods: {
			async setCheckState(index) {
				let state = 'WAITING'
				if (index == 0) {
					this.loadingUnpass = true;
					state = 'REJECTED'
				} else {
					this.loadingPass = true;
					state = 'PASSED'
				}
				try {
					let result = await this.$http.post(this,`/project/${this.currentId}/audit/${state}`);
					if (index == 0) {
						this.loadingUnpass = false;
					} else {
						this.loadingPass = false;
					}
					if (result && result.code == 200) {
						this.$message({
							message: '完成',
							type: 'success'
						});
						this.getList(this.currentPage - 1);
					}
				} catch (e) {
					this.loadingPass = false;
					this.loadingUnpass = false;
				}
				this.checkVisible = false;
			},
			handleSelectionChange(val) {
				console.log('checkb0x-', val)
				this.multipleSelection = val;
			},
			formatDatas(item) {
				return {
					time: item.time,
					// income: item.income,
					open: item.open,
					share: item.share,
					remainder: item.remainder,
				};
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList(this.currentPage - 1);
			},
			getFilterList() {
				this.currentPage = 1;
				this.getList(this.currentPage - 1);
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getList(this.currentPage - 1);
			},
			async getList(index) {
				let result = await this.$http.get(this,'/commission/statistics',{ pageIndex: index, pageSize: this.pageSize });
				if (result && result.code == 200) {
					this.tableData = result.data.data.map((item) => { return this.formatDatas(item) });
					this.totalNumber = result.data.count
					this.page = result.data.page + 1
				}
			},
			formatCheckState(row, column) {
				let temp = this.checkState.filter((item) => {
					return item.value == row.auditState;
				})
				return temp[0].label;
			},
			formateDate(row, column) {
				if (!row.time) {
					return '';
				}
				return new Date(row.time).format("yyyy年MM月dd日");
			},
			formateStatus(row, column) {
				if (!row.status) {
					return '';
				} else if (row.status == 'COMPLETE') {
					return '已处理';
				} else if (row.status == 'WAITING') {
					return '待处理';
				}
				return '';
			},
			formateDate1(row, column) {
				if (!row.updateTime) {
					return '';
				}
				return new Date(row.updateTime).format("yyyy/MM/dd");
			},
			handleCharge: function (index, row) {
				this.currentId = row.id;
				this.chargeFormVisible = true;
			},
			handleCheck: function (index, row) {
				this.currentId = row.id;
				this.$confirm('您确认已经将客户提现金转给客户？', '提现', {}).then(async () => {
					try{
						await this.withdrawalAccept(row.id);
						this.getList(this.currentPage - 1);
					} catch(e) {
						this.$message({
						message: '处理失败，请重试',
						type: 'fail'
					});
					}

				});
			},
			async withdrawalAccept(id) {
				let url = `/withdrawal/${id}/complete`
				let result = await this.$http.post(this,url);
				if (result && result.code == 200) {
					this.$message({
						message: '处理成功',
						type: 'success'
					});
				}
			},
			handleSetting: function (index, row) {
				this.settingVisible = true;
				//this.currentId = row.id;
				this.currentItem = this.tableData.filter((item)=>{
					return row.id == item.id;
				})[0]
				console.log('this.currentItem--',this.currentItem)
			},
			//显示新增界面
			handleAdd: function () {
				this.$router.push('/table/table1')
				this.addFormVisible = true;
				this.addForm = {
					name: '',
					sex: -1,
					age: 0,
					birth: '',
					addr: ''
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							editUser(para).then((res) => {
								this.editLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								//	this.getUsers();
							});
						});
					}
				});
			},
			chargeSubmit() {
				this.$refs.chargeform.validate(async (valid) => {
					if (valid) {
						this.chargeLoading = true;
						let para = {
							amount: this.chargeForm.money,
						}
						let result = await this.$http.post(this,`/project/${this.currentId}/recharge`, para);
						if (result.code == 200) {
							this.chargeLoading = false;
							this.$message({
								message: '充值成功',
								type: 'success'
							});
							this.chargeForm.money = 0;
							this.chargeFormVisible = false;
							this.getList(this.currentPage - 1);
						} else {
							this.$message({
								message: '充值失败',
								type: 'fail'
							});
						}
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.addForm);
							para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
							addUser(para).then((res) => {
								this.addLoading = false;
								//NProgress.done();
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['addForm'].resetFields();
								this.addFormVisible = false;
								//this.getUsers();
							});
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			confirm: function () {
				this.$confirm('确认修改吗？', '抽佣设置', {}).then(async () => {
					await this.setCommision();
				});
			},
			async setCommision() {
				let result = await this.$http.post(this, '/config/commission/set',{commission : this.commissionRatio/100});
				if (result && result.code == 200) {
					this.$message({
						message: '设置成功',
						type: 'success'
					});
				}
			},
			async getCommisionRatio() {
				let result = await this.$http.get(this, '/config/commission');
				if (result && result.code == 200) {
					this.commissionRatio = result.data*100
				}
			},
			async getCommision() {
				let result = await this.$http.get(this, '/commission/current');
				if (result && result.code == 200) {
					this.amount = result.data ;
				}
			},
			async refresh() {
			 await this.getCommision();
			 this.$message({
						message: '刷新成功',
						type: 'success'
					});
			},
	  	},
		mounted() {
			this.getCommisionRatio();
			this.getCommision();
			this.getList(0);
		}
	}

</script>

<style scoped>
	.el-button+.el-button {
		margin-left: 4px;
	}

	.el-button--small,
	.el-button--small.is-round {
		padding: 8px 10px;
	}

	.el-button--text {
		padding-left: 0;
		padding-right: 0;
	}
	.work-image {
		width: 200px;
		height: auto;
	}
	.avatar {
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}
	.amount {
		font-size: 20px;
		font-weight: bold;
		margin-right: 16px;
	}
</style>
